export default __webpack_public_path__ + "static/media/travel.9f472dcc.svg";